














import Vue from 'vue'
import BatchTable from '@/UI/Batch/BatchTable.vue'
import { BatchDto } from '@/Application/Batch'

export default Vue.extend({
  name: 'BatchDetail',
  components: { BatchTable },
  props: {
    label: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      required: true,
      validator: (value: string): boolean => {
        return ['Risco', 'Resultas'].indexOf(value) !== -1
      }
    },
    batches: {
      type: Array as () => BatchDto[],
      required: true
    },
    checks: {
      type: Boolean,
      default: false,
      required: false
    },
    selectedChecks: {
      type: Array as () => string[],
      required: false
    },
    procedureType: {
      type: String,
      required: true
    }
  },
  computed: {
    showFianza (): boolean {
      return this.procedureType === 'PX'
    }
  }
})
